module.exports = __webpack_public_path__ + "static/media/glanum_weinraeucherei_tn.e818250b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_weinraeucherei_tn.jpg
// module id = 726
// module chunks = 0